import { supabase } from "../supabaseClient";

export const deleteUser = async (): Promise<{
  success: boolean;
  error?: string;
}> => {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();

  if (userError || !user) {
    return { success: false, error: "Käyttäjää ei löytynyt." };
  }

  const userId = user.id;

  // 1. Poista käyttäjän raaka-aineet
  const { error: deleteIngredientsError } = await supabase
    .from("user_ingredients")
    .delete()
    .eq("user_id", userId);

  if (deleteIngredientsError) {
    return { success: false, error: "Raaka-aineiden poisto epäonnistui." };
  }

  // 2. Poista käyttäjän rivi users-taulusta
  const { error: deleteUserError } = await supabase
    .from("users")
    .delete()
    .eq("id", userId);

  if (deleteUserError) {
    return { success: false, error: "Käyttäjätiedon poisto epäonnistui." };
  }

  // 3. Kirjaa ulos
  const { error: signOutError } = await supabase.auth.signOut();

  if (signOutError) {
    return { success: false, error: "Uloskirjautuminen epäonnistui." };
  }

  return { success: true };
};
